export const tenantStatsCardTypes = ['reports', 'presets', 'definitions', 'views', 'sources', 'roles'] as const;
